import { CmErrorText, CmLongLoading } from '@/components/uiParts';

import { DeliveryInHouseTemplate } from './DeliveryInHouseTemplate';
import { useDeliveryAreas } from './useDeliveryAreas';

const DeliveryInHousePage: React.FC = () => {
  const { authStoresDeliveryAreas, isLoading, error } = useDeliveryAreas();

  if (error !== null) {
    return <CmErrorText>{error?.message}</CmErrorText>;
  }
  if (isLoading) {
    return <CmLongLoading />;
  }

  return (
    <DeliveryInHouseTemplate {...{ authStoresDeliveryAreas, isLoading }} />
  );
};

export default DeliveryInHousePage;
